function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#506EAF",
  d: "M0,80C0,35.817,35.817,0,80,0s80,35.817,80,80s-35.817,80-80,80S0,124.183,0,80"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M80,49.095c3.313,0,6-2.688,6-6v-0.139c0-3.313-2.687-6-6-6c-3.313,0-6,2.687-6,6v0.139 C74,46.407,76.688,49.095,80,49.095"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  d: "M92.634,109.044H84V61.736c0-2.209-1.791-4-4-4h-8.447c-2.209,0-4,1.791-4,4s1.791,4,4,4H76v43.308h-8.633 c-2.209,0-4,1.791-4,4s1.791,4,4,4h25.267c2.209,0,4-1.791,4-4S94.843,109.044,92.634,109.044"
});

var SvgInfoAccent = function SvgInfoAccent(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 161,
    height: 161,
    viewBox: "-0.665 -0.396 161 161",
    enableBackground: "new -0.665 -0.396 161 161",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInfoAccent, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/info_accent.5b4029e2.svg";
export { ForwardRef as ReactComponent };